import React, { useState } from "react"
import SideBar from "../../components/sidebar/Sidebar"
import "./Beni.scss"
import AddIcon from "@mui/icons-material/Add"
import { Fab } from "@mui/material"
import TabellaBene from "../../components/bene/BeneTableComponent"

const BenePage: React.FC<{}> = () => {

  const [fabVisible, setFabVisible] = useState(true)

  return (
    <div className="home">
      {fabVisible &&
        <Fab
          onClick={() => setFabVisible(false)}
          sx={{ position: "fixed", bottom: 16, right: 16 }} color="primary" aria-label="add">
          <AddIcon />
        </Fab>
      }
      <SideBar />
      <div className="homeContainer">
        <TabellaBene
          alterFabVisibility={setFabVisible}
          fabVisible={fabVisible}
          enableCreate={true}
          anagrafica_cliente_id={-1}
          dettaglio={true} // TODO: verify
        />
      </div>
    </div>
  )
}

export default BenePage
